import { UserDto } from './dto';

export abstract class UserHelper {
	public static isAdmin(user?: UserDto): boolean {
		return (user?.groups ?? []).includes('/SMENADC/SMENADC. Администрирование');
	}

	public static isManager(user?: UserDto): boolean {
		return (user?.groups ?? []).includes('/SMENADC/SMENADC. Управление участком');
	}

	public static isCustomer(user?: UserDto): boolean {
		return (user?.groups ?? []).includes('/SMENADC/SMENADC. Общее');
	}

	public static isTabel(user?: UserDto): boolean {
		return (user?.groups ?? []).includes('/SMENADC/SMENADC. Табелирование');
	}

	public static isHr(user?: UserDto): boolean {
		return (user?.groups ?? []).includes('/SMENADC/SMENADC. Управление персоналом');
	}

	public static isNoGroups(user?: UserDto) {
		return (
			!this.isAdmin(user) &&
			!this.isManager(user) &&
			!this.isCustomer(user) &&
			!this.isTabel(user) &&
			!this.isHr(user)
		);
	}

	/**
	 * Является ли пользователем кабинета
	 */
	public static isCabinet(user: UserDto): boolean {
		return this.isAdmin(user) || this.isManager(user);
	}

	/**
	 * Получить имя пользователя
	 * @param user
	 */
	public static getName(user?: UserDto | null): string {
		let name = user?.name ?? `${user?.given_name ?? ''} ${user?.family_name ?? ''}`.trim();
		if (name.length <= 0) name = user?.preferred_username ?? '';
		return name;
	}
}
